import { forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import classNames from 'classnames';
import { ThemeText } from '../../context/theme/ThemeConstantsUpdated';

const { mainText, mainTextInverted } = ThemeText;

export const NavLink = forwardRef<HTMLAnchorElement, LinkProps & { isVibrant?: boolean; isDisabled?: boolean }>(
  (props, ref) => {
    const { isVibrant, isDisabled } = props;
    const isActive = location.pathname === props.to;

    return (
      <Link
        ref={ref}
        {...props}
        className={classNames(
          isActive ? 'underline decoration-2 underline-offset-[6px]' : 'hover:opacity-80',
          isVibrant ? mainTextInverted : mainText,
          'text-sm font-semibold leading-6 tracking-wide',
          isDisabled && 'pointer-events-none opacity-50'
        )}
      />
    );
  }
);
